export default "__VITE_ASSET__5fe549c5__"